var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharedProjectHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.001,
    height: 112.002,
    viewBox: "0 0 135.001 112.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28042",
    "data-name": "Group 28042",
    transform: "translate(-922.728 -259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13176",
    "data-name": "Rectangle 13176",
    width: 135,
    height: 112,
    rx: 10,
    transform: "translate(922.729 259)",
    fill: "#00aec7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28038",
    "data-name": "Group 28038",
    transform: "translate(552.729 -264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_19",
    "data-name": "Subtraction 19",
    d: "M15160.626,1123h-94.354a10.013,10.013,0,0,1-10-10v-92a10.011,10.011,0,0,1,10-10h115a10.011,10.011,0,0,1,10,10v63.458l-39.524-30.747-29.973-12.43-29.687,12.529,16.269,7.76-14.833,6.476,12.915,5.705-12.915,5.48,27.079,14.4,40.022,29.372Z",
    transform: "translate(-14686.271 -488)",
    fill: "#00aec7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28024",
    "data-name": "Group 28024",
    transform: "translate(142.441 -26.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_33823",
    "data-name": "Path 33823",
    transform: "translate(876.099 354.707) rotate(135)",
    fill: "#00aec7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.0287971496582 40.98695373535156 L 13.28925609588623 29.80693435668945 L 1.801198959350586 1.759254693984985 L 30.40176773071289 12.69419479370117 L 41.0287971496582 40.98695373535156 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.602413177490234 3.518516540527344 L 14.05463409423828 29.03724098205566 L 39.29281234741211 39.20912170410156 L 29.62398147583008 13.46742057800293 L 3.602413177490234 3.518516540527344 M -3.814697265625e-06 -3.814697265625e-06 L 31.17954635620117 11.92096710205078 L 42.76477813720703 42.76477813720703 L 12.52388763427734 30.57662582397461 L -3.814697265625e-06 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_33822",
    "data-name": "Path 33822",
    transform: "translate(876.099 342.729) rotate(135)",
    fill: "#00aec7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.0287971496582 40.98695373535156 L 13.28925609588623 29.80693435668945 L 1.801198959350586 1.759254693984985 L 30.40176773071289 12.69419479370117 L 41.0287971496582 40.98695373535156 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.602413177490234 3.518516540527344 L 14.05463409423828 29.03724098205566 L 39.29281234741211 39.20912170410156 L 29.62398147583008 13.46742057800293 L 3.602413177490234 3.518516540527344 M -3.814697265625e-06 -3.814697265625e-06 L 31.17954635620117 11.92096710205078 L 42.76477813720703 42.76477813720703 L 12.52388763427734 30.57662582397461 L -3.814697265625e-06 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33821",
    "data-name": "Path 33821",
    d: "M0,0,31.18,11.921,42.765,42.765,12.524,30.577Z",
    transform: "translate(876.099 328.619) rotate(135)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    transform: "translate(953 323)",
    fill: "#fff",
    stroke: "#00aec7",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_137",
    "data-name": "Union 137",
    d: "M15616.777,759.8a3.328,3.328,0,0,1,.054-.588l-2.683-1.792a3.049,3.049,0,0,1-2.038.783,3.2,3.2,0,0,1,0-6.4,3.056,3.056,0,0,1,2.182.918l2.614-1.61a3.273,3.273,0,0,1-.129-.908,3.113,3.113,0,1,1,3.111,3.2,3.058,3.058,0,0,1-2.183-.92l-2.612,1.612a3.276,3.276,0,0,1,.129.909,3.228,3.228,0,0,1-.19,1.1l2.468,1.65a3.072,3.072,0,0,1,2.389-1.15,3.2,3.2,0,1,1-3.111,3.2Z",
    transform: "translate(-14649 -417)",
    fill: "#00aec7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedProjectHover);
export default __webpack_public_path__ + "static/media/shared_project_hover.1f4006add90f91552d424dc770cfd603.svg";
export { ForwardRef as ReactComponent };